import { formatDate, useDateTime } from '@superdispatch/dates';
import { renderChildren } from '@superdispatch/ui';
import { DateTime } from 'luxon';
import { ReactElement, useMemo } from 'react';
import { composeSavedSearchTitle } from 'shared/modules/loadboard/PostingSearchCriteriaDTO';
import { PostingSavedSearchDTO } from '../../data/dto/PostingSavedSearchDTO';

function useSavedSearchTitle(savedSearch: PostingSavedSearchDTO): string {
  return useMemo(
    () =>
      savedSearch.description ||
      composeSavedSearchTitle(savedSearch.search_criteria),
    [savedSearch],
  );
}

interface SavedSearchTitleProps {
  savedSearch: PostingSavedSearchDTO;
}

export function SavedSearchTitle({
  savedSearch,
}: SavedSearchTitleProps): null | ReactElement {
  const title = useSavedSearchTitle(savedSearch);

  return renderChildren(title);
}

interface SavedSearchExpirationTextProps {
  savedSearch: PostingSavedSearchDTO;
}

export function SavedSearchExpirationText({
  savedSearch,
}: SavedSearchExpirationTextProps) {
  const expireDate = useDateTime(savedSearch.alert_expires_at, {
    format: 'JodaISO',
  });
  return renderChildren(
    savedSearch.alert_duration === 'permanent'
      ? 'Permanent alert'
      : savedSearch.alert_duration === 'today'
        ? 'Alert today only'
        : savedSearch.alert_duration === 'week' && savedSearch.alert_expires_at
          ? `Alert until ${formatDate(expireDate, {
              variant: expireDate.hasSame(DateTime.local(), 'day')
                ? 'Time'
                : 'ShortDate',
            })}`
          : 'Unknown',
  );
}
